import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectAllActivityLogByUser, STATUS } from "../../../../redux/features/activityLog/activityLogSlice";
import { getAllActivityLogsByUser } from "../../../../redux/features/activityLog/activityLogService";
import Timeline from "../../../../components/Timeline";
import TimelineSkeleton from "../../../../components/Skeleton/TimelineSkeleton";
import styles from './index.module.css';

const limitSize = [
    { index: 0, name: '10', value: 10 },
    { index: 1, name: '20', value: 20 },
    { index: 2, name: '50', value: 50 },
    { index: 3, name: '100', value: 100 },
    { index: 4, name: 'Unlimited', value: 1 },
];

const UserActivityLogs = () => {
    const dispatch = useDispatch();
    const { data: userActivityLogs, status } = useSelector(selectAllActivityLogByUser);

    const [pageLimit, setPageLimit] = useState(10);

    const fetchUserActivityLogs = useCallback(
        (filters = {}) => {
            const params = {
                ...(pageLimit > 1 ? { limit: pageLimit } : {}),
                skip: 0,
                ...filters,
            };
            dispatch(getAllActivityLogsByUser(params));
        },
        [dispatch, pageLimit]
    );

    useEffect(() => {
        fetchUserActivityLogs()
    }, [fetchUserActivityLogs]);

    const handleLimit = async (option) => {
        setPageLimit(option);
    };

    return (
        <>
            <div className={`main-card`}>
                <h1 className={`form-title`}>Activity Logs</h1>
                <div className={styles.searchSec}>
                    {userActivityLogs?.data?.length > 0 &&
                        <div className={styles.btnGroup}>
                            {limitSize.map((limit) => (
                                <div key={limit.index} className={pageLimit === limit.value ? styles.activeBtn : styles.limitBtn} onClick={() => handleLimit(limit.value)}>{limit.name}</div>
                            ))}
                        </div>
                    }
                </div>
                <div className={styles.cardSec}>
                    <>
                        {(status === STATUS.IDLE || status === STATUS.LOADING) && (
                            <TimelineSkeleton />
                        )}
                        {status === STATUS.FAILED && (
                            <div className="error-text">
                                Failed to load activity logs
                            </div>
                        )}
                        {status === STATUS.SUCCEEDED && userActivityLogs.data.length === 0 && (
                            <div>No activity logs found</div>
                        )}
                        {status === STATUS.SUCCEEDED && userActivityLogs.data.length > 0 && (
                            <Timeline data={userActivityLogs} />
                        )}
                    </>
                </div>
            </div>
        </>
    );
};
export default UserActivityLogs;
